import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PlayerProtectionComponent } from './player-protection.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { DateTimestampFormatPipe } from 'src/app/pipes/date-timestamp-format.pipe';


@NgModule({
  declarations: [
    PlayerProtectionComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    DateTimestampFormatPipe,
  ]
})
export class PlayerProtectionModule {}